import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {Carousel } from "react-responsive-carousel";


const images = [
  require('../../images/carousel/foto13.jpg'),
  require('../../images/carousel/foto6.jpg'),
  require('../../images/carousel/foto4.jpg'),
  require('../../images/carousel/foto10.jpg'),
  require('../../images/carousel/foto5.jpg'),
  require('../../images/carousel/foto14.jpg'),
  require('../../images/carousel/foto15.jpg'),
  require('../../images/carousel/foto9.jpg'),
  require('../../images/carousel/foto16.jpg'),
];



const styleCard = {
    display: 'flex',
    flexDirection:'column',
    // width:'360px',
    // height:'520px'
}

const styleImg = {
    width: '100%',
    height:'100%',
    borderRadius:'4px',
    objectFit: 'cover', 
}

const styleWrapper = {
    width:'160px',
    height: '160px',
    marginBottom: '10px',
}



const ImgCarousel = () =>{
    return (
        <div 
        // className={styleCard}
         style={styleCard}>
            <Carousel
            
                showArrows={true}
                showStatus={false}
                showThumbs={true}
                swipeable={true}
                emulateTouch={true}
                autoPlay={false}
                infiniteLoop={true}
                stopOnHover={true}
            >
                
      {images.map((imgSrc, index) => (
        <div key={index} className={styleWrapper}>
          <img src={imgSrc} style={styleImg} 
          whileHover={{
                scale: 1.15,
                borderColor: '#F3D188',
              }} alt={`Obrazek ${index + 1}`} />
        </div>
      ))}
    
            </Carousel>
        </div>
    )
};


export default ImgCarousel;


